import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";
import { useLocation, useNavigate } from "react-router-dom";

import { Button } from "components/AtomsV2";
import { Icon } from "components/ShellV2";

const versionBasePath = (communityId, entityType, entityId) =>
  `/communities/${communityId}/versions/${entityType}/${encodeURIComponent(entityId)}`;

function VersionManagementButtons({ communityId, entityType, entityId, label, returnTo, compact }) {
  const navigate = useNavigate();
  const location = useLocation();
  const { t } = useTranslation("common");
  const basePath = versionBasePath(communityId, entityType, entityId);
  const routeState = { label, returnTo: returnTo || location.pathname };
  const addVersion = () => {
    if (entityType === "contract") {
      navigate(`/communities/${communityId}/infrastructure/contracts/new`, {
        state: {
          ...routeState,
          meterId: entityId,
          meterIdentifier: label,
          action: "new",
        },
      });
      return;
    }
    navigate(`${basePath}/new`, { state: routeState });
  };

  if (compact) {
    return (
      <button
        type="button"
        className="rec-icon-btn"
        title={t("versioning.buttons.viewHistory")}
        onClick={(event) => {
          event.stopPropagation();
          navigate(basePath, { state: routeState });
        }}
      >
        <Icon name="history" />
      </button>
    );
  }

  return (
    <div className="flex gap-2 flex-wrap">
      <Button variant="ghost" onClick={() => navigate(basePath, { state: routeState })}>
        <Icon name="history" />
        {t("versioning.buttons.history")}
      </Button>
      <Button onClick={addVersion}>
        <Icon name="add" />
        {t("versioning.buttons.addVersion")}
      </Button>
    </div>
  );
}

VersionManagementButtons.propTypes = {
  communityId: PropTypes.string.isRequired,
  entityType: PropTypes.oneOf([
    "config",
    "membership",
    "meter",
    "resource",
    "ownership",
    "contract",
    "resp",
    "fixedBilateral",
    "ems",
  ]).isRequired,
  entityId: PropTypes.string.isRequired,
  label: PropTypes.string,
  returnTo: PropTypes.string,
  compact: PropTypes.bool,
};

VersionManagementButtons.defaultProps = {
  label: undefined,
  returnTo: undefined,
  compact: false,
};

export { versionBasePath };
export default VersionManagementButtons;
